<script setup lang="ts">
import { scaledNftImg, ThumbSize } from "~/composables/useThumbs";
import { computed, ref } from "vue";
import { CardType, type NftEquipment, type NftSkill } from "fungi-types";

const props = withDefaults(
  defineProps<{
    nft: NftSkill | NftEquipment;
    background?: boolean;
  }>(),
  {
    background: true,
  }
);

const emits = defineEmits<{
  (event: "skill-click", nft: NftSkill): void;
  (event: "equipment-click", nft: NftEquipment): void;
}>();

const nftImage = ref();

function handleCardClick() {
  if (props.nft.cardType === CardType.NftEquipment) {
    emits("equipment-click", props.nft as NftEquipment);
  } else {
    emits("skill-click", props.nft as NftSkill);
  }
}

const IMG = computed(() => {
  return scaledNftImg(props.nft.image, ThumbSize.XL);
});

// random number between 1 and 8
const randomNum = Math.floor(Math.random() * 8) + 1;
const IMG_TEST = computed(() => {
  return `https://storage.googleapis.com/fungiball-assets/presale-2026/card-${randomNum}.png`;
});
</script>

<template>
  <div class="flex flex-col py-4 px-3 gap-3" @click.stop="handleCardClick">
    <div class="flex relative justify-center h-fit">
      <div class="relative w-fit">
        <image-skeleton
          ref="nftImage"
          :src="IMG"
          :alt="(nft as NftSkill).slug || nft?.title"
          :scarcity="(nft as NftSkill).scarcity"
          :aspect-ratio="0.62"
        />
      </div>
    </div>
    <div class="flex flex-col gap-2 w-full">
      <slot name="footer-data" />
    </div>
    <slot name="cta" />
  </div>
</template>
